export interface ICustomValue {
  label: string
  value?: string
  children?: ICustomValue[]
  meta?: {
    [key: string]: any
  }
}

export interface ICustomField {
  id: string
  name: string
  fieldKey: string
  dataType: string
  picklistOptions: string[]
}

export type Menu = { text: string; value?: string; menu?: Menu[] }

export interface ITriggerLinks {
  id: string
  name: string
  redirectTo: string
  locationId: string
}
export interface SelectOptions {
  label: string
  value: string
}
export interface ITag extends SelectOptions {}

export interface FetchSmartList {
  locationId: string

  assignedTo: string
  page: number
  filters: Array<any>
  sort: []
  pageLimit: number
  searchAfter: null
  justIds: boolean
}

export interface FetchTagsParams {
  locationId: string
  query?: string
  skip?: number
  limit?: number
}

export interface ISmartList {
  location_id: string
  user_id: string
}
export interface recordListSchedule {
  scheduleStart: string
  scheduleTimeZone: string
}
export interface IContactSearchOptions {
  locationId: string
  query?: string
  tag?: string
  limit?: number
  assignedTo: string
  page?: number
}

export interface ICreateTemplateFromCampaign {
  locationId: string
  updatedBy?: string
  templateDataUrl?: string
}
export interface BulkEmailOpSpecs {
  opType: 'bulk-email'
  templateId?: any
  attachments?: any[]
  subject?: string
  thread_id?: any
  from?: string
  assignedTo?: string
  reply_message_id?: any
  templateName?: string
  downloadUrl?: string
  useNewApi: boolean
  replyToAddress?: string
}
export interface INormalEmailScheduleInfo {
  sprintSchedule?: any
  opSpecs: BulkEmailOpSpecs
  recordListSchedule?: recordListSchedule
  opSource: 'email-builder'
  freezeList: boolean
  description: string
}

export interface IRSSScheduleInfo {
  name?: string
  repeatAfter: string
  repeatAfterTime: string
  rssFeedURL: string
  subject?: string
  from?: string
  templateName?: string
  startAtDay?: string
  startAtMonthDay?: string
  debug?: boolean
  freezeList?: boolean
  useNewApi: boolean
  replyToAddress?: string
  timeZone?: string
  sendDays?: string[]
  firstExecutionDate?: string
  rssFeedLimit?: number
}

export interface ABTestVariationInfo {
  subject: string

  documentId?: string

  bulkRequestId?: string

  statics?: Object

  contactsCount?: number

  searchAfter?: Object
  templateDataDownloadUrl?: string
  downloadUrl?: string
  status?: string
}

export interface IEmailScheduleOptions {
  type?: string
  templateType?: string
  locationId: string
  templateId?: string
  byUserId: string
  byUserName?: string
  sendDays?: Array<string>
  recordIds?: string[]
  timeZone?: string
  rssInfo?: IRSSScheduleInfo
  bulkReqInfo?: INormalEmailScheduleInfo

  filters?: {}
  downloadUrl?: string
  name?: string
  campaignId?: string
  parentId?: string
  previewText?: string
  freezeList?: boolean
  abTestInfo?: ABTestInfo
  isPlainText?: boolean
  hasTrackingLinks?: boolean
  bulkScheduleType?: BulkActionScheduleType
  hasUtmTracking?: boolean
  segmentType?: string
}

export enum BulkActionScheduleType {
  SEND_NOW = 'NOW',
  SEND_LATER = 'SCHEDULED',
  DRIP = 'DRIP',
}

export interface IEmailResendOptions {
  resendStatus: string
  locationId: string
  templateId?: string
  byUserId: string
  byUserName?: string
  campaignId: string
  parentId?: string
  subject: string
  scheduleTime: string
  useNewApi: boolean
  assignedTo?: string
  isDebug?: boolean
}

export interface IUpdateScheduleOptions {
  locationId: string
  name?: string
  updatedBy?: string
}

export interface IBulkEmailOptions {
  locationId: string
  byUserId: string
  recordIds?: string[]
  sprintSchedule?: any
  opSpecs: BulkEmailOpSpecs
  recordListSchedule?: recordListSchedule
  opSource: 'email-builder'
  filters?: {}
  byUserName?: string
  freezeList: boolean
  description: string
}
export interface IScheduleMeta {
  filters?: any

  recordIds?: string[]

  byUserName?: string

  byUserId?: string

  timeZone?: string

  bulkReqInfo?: IBulkEmailOptions

  rssInfo?: IRSSScheduleInfo
  previewText?: string
  segmentType?: string

  bulkReqStatus: any //TODO hkurra use IbulkRequestStatus Interface here
  abTestInfo?: ABTestInfo
}
export interface ISchedule {
  locationId: string
  type: string
  templateId: string
  downloadUrl: string
  templateType: string
  status: string
  nextExecution: string
  lastExecution: string
  currentExecution: string
  bulkRequestId: string
  taskRequestId: string
  sendDays: string[]
  meta: IScheduleMeta
  deleted: boolean
  emailStatus: string
  templateName?: string
  templateDataDownloadUrl?: string
  name?: string
  loading?: string
  id: string
  updatedAt: string
  campaignType?: string
  lastExecutionStatus?: string
  totalCount?: number
  failed?: number
  nextProcessingOn?: string | number
  createdAt: string
  dateAdded?: string
  dateScheduled?: string
  parentId?: string
  documentId?: string
  ABTestInfo?: ABTestInfo
  subject?: string
  hasTracking?: boolean
  bulkActionVersion?: string
  hasUtmTracking?: boolean
  source?: string // workflow keys
  sourceId?: string
}

export interface SelectOptions {
  label: string
  value: string
}
export interface RSSEmailCampaignInfo {
  rssFeedURL: string
  recurringPeriod: string
  startAtTime: string
  sendDays: Array<string>
  rssFeedURLErrorMessage: string | undefined
  name?: string
  startAtDay?: string
  startAtMonthDay?: string
  rssFeedLimit?: number | undefined
}
export interface DripModeInfo {
  startOnDate: string
  batchQuantity: number
  repeatAfter: number
  selectedAfterUnit: string
  startFromTime: string
  endAtTime: string
  endDateWarning?: string
  sendDays: Array<string>
}
export interface IContact {
  id: string
  value: string
  label: string
}

export interface IPreviewMessage {
  email: string
  from_address: string
  location_id: string
  message: string
  subject: string
  type: string
  user_id: string
  template_id: string
  rss_feed_url: string
}
export interface FetchHtmlPreview {
  locationId: string
  id: string
  version?: number
}
export interface Item {
  id: number
  updatedAt: Date
  updatedBy: string
  versionId: string
}
export interface SwitchVersionOptions {
  templateId: string
  updatedBy: string
  versionId: string
  locationId: string
}

export interface FetchTemplateVersions {
  id: string
  locationId: string
}

export interface ICampaignStatsReports {
  bulk_req_id: string
  location_id: string
  maxRows: number
  option: string
  showCount: boolean
  start: number
  page?: number
  bulkActionVersion?: string
  bulkV2FilterType?: string
  bulkV2FilterSubType?: string
}

export interface INewCampaignStatsReports {
  bulkReqId: string
  locationId: string
  maxRows: number
  option: string
  showCount: boolean
  start: number
  page?: number
  sourceId?: string
  subSourceId?: string
}

export interface ICampaignMeta {
  createdAt: string
  documentId: string
  id: string
  locationId: string
  name: string
  previewUrl: string
  updatedAt: string
  nextExecution?: string
  nextProcessingOn?: string
  status: string
}

export enum ScheduleStatus {
  ACTIVE = 'active',
  PAUSE = 'pause',
  COMPLETE = 'complete',
  CANCELLED = 'cancelled',
  RETRY = 'retry',
  DRAFT = 'draft',
}

export enum EmailScheduleStatus {
  ALL = 'all',
  NOT_STARTED = 'not-started',
  PAUSED = 'paused',
  CANCELLED = 'cancelled',
  PROCESSING = 'processing',
  RESUMED = 'resumed',
  NEXT_DRIP = 'next-drip',
  COMPLETE = 'complete',
  SUCCESS = 'success',
  ERROR = 'error',
  WAITING = 'waiting',
  QUEUED = 'queued',
  QUEUEING = 'queueing',
  READING = 'reading',
  SCHEDULED = 'scheduled',
}

export enum EmailCampaignType {
  RSS = 'rss',
  DRIP_SCHEDULE = 'drip_schedule',
  SEND_NOW = 'send_now',
  SCHEDULED = 'schedule_later',
  AB_TEST = 'abtest',
}

export type editorType = 'html' | 'builder'

export interface Template {
  name?: string
  openRate?: string
  bounceRate?: string
  archived?: string | boolean
  builderVersion?: string
  fromName?: string
  fromAddress?: string
  subjectLine?: string
  previewText?: string
  lastUpdated?: string
  thumbnailImage?: string
  updatedBy?: string
  locationId: string
  previewUrl?: string
  type?: string
  rssFeedURL?: string
}

export interface ABTestInfo {
  testType: string
  testDuration: number
  variationCount: number
  testSize: number
  winningCriteria: string
  variations: Array<ABTestVariationInfo>
  winningVariationIndex?: number
  debug?: boolean
  //below properties are not accepted by server, please delete them before patching or updating
  isABTestCampaign: boolean
  currentABTestVariationIndex?: number
}

export interface IScheduleIntialOptions {
  subject: string
  fromAddress: string
  fromName: string
  scheduleStartDate: string
  scheduleStartTime: string
  dripModeData: DripModeInfo
  selectedContacts?: string[]
  previewText?: string
  replyToAddress?: string
  hasTrackingLinks?: boolean
  hasUtmTracking?: boolean
  status?: string
}

export interface GetSavedElementParams {
  locationId: string
  offset?: number
  limit?: number
  search?: string
  sort?: object
}

export interface CreateSavedElement {
  name: string
  locationId: string
  type: string
  dnd: object
  userId: string
  tagName: string
}
export interface UpdateSavedElement {
  name?: string
}

export interface SavedElement {
  _id: string
  locationId: string
  name: string
  type: string
  downloadUrl: string
  downloadPath: string
  previewUrl: string
  previewPath: string
  thumbnailUrl: string
  thumbnailPath: string
  createdAt: string
  updatedAt: string
  meta: Object
}

export interface BusinessProductPrice {
  _id: string
  __v: number
  amount: number
  createdAt: string
  currency: string
  deleted: boolean
  locationId: string
  membershipOffers: any[]
  name: string
  product: string
  type: string
  updatedAt: string
  userId: string
}

export interface BusinessProduct {
  _id: string
  type: string
  parentId: string | null
  archived: boolean
  deleted: boolean
  locationId: string
  name: string
  image: string
  statementDescriptor: string
  userId: string
  productType: string
  createdAt: string
  updatedAt: string
  description: string
  prices: BusinessProductPrice[]
}

export type Option<T> = {
  label: string
  value: T
}

export type BusinessProductPriceOption = BusinessProductPrice & Option<string>

export type BusinessProductOption = BusinessProduct &
  Option<string> & {
    prices: BusinessProductPriceOption[]
  }

export interface CreateImporterTaskParams {
  locationId: string
  userId: string
}

export interface TrackingLinkStats {
  locationId: string
  campaignId: string
  timeZone?: string
  shortId?: string
}

export interface EmailStatsV2Response {
  actionDate: string
  actionType: string
  bulkReqId: string
  name: string
  email: string
  error: string
  locationId: string
  recordId: string
  status: string
}

export interface SendVerificationEmailParams {
  locationId: string
  email: string
}

export interface VerifyEmailParams {
  locationId: string
  email: string
  otp: number
}

export interface CreateThumbnailUrl {
  previewUrl: string
  bucketName: string
  thumbnailPath: string
}

export interface fetchAllCountdownTimers {
  locationId: string
  status: string
  isExpired: boolean
  limit?: number
  offset?: number
}
